import React from "react";

export const Textbox = ({
  Label,
  name,
  Type = "text",
  Placeholder = "",
  register,
  errors,
  validationRules,
  watch,
  disabled = false,
  ...rest
}) => {
  const value = watch(name);
  const isRequired = validationRules?.required;
  const { style, ...restProps } = rest;

  return (
    <div className="mb-4">
      {Label ? (
        <label className="block mb-2 text-sm font-bold text-gray-700">
          {Label} {isRequired && <span className="text-red-500">*</span>}
        </label>
      ) : (
        ""
      )}
      <input
        disabled={disabled}
        className={`w-full px-4 py-2 text-base bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent transition-all duration-200 disabled:bg-gray-100 disabled:cursor-not-allowed
            ${errors[name] ? 'border-red-500 focus:ring-red-200' : ''}
            ${!errors[name] && value && !disabled ? 'border-green-500' : ''}
        `}
        placeholder={Placeholder}
        type={Type}
        {...register(name, validationRules)}
        {...restProps}
      />
      {errors[name] && (
        <div className="text-red-500 text-xs mt-1">
          {errors[name].message}
        </div>
      )}
    </div>
  );
};
